import { render, staticRenderFns } from "./ModelRecordDialog.vue?vue&type=template&id=6f4e70d7&scoped=true&"
import script from "./ModelRecordDialog.vue?vue&type=script&lang=js&"
export * from "./ModelRecordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4e70d7",
  null
  
)

export default component.exports